import React, { useState, useEffect } from "react"
import Book_A_Valuation from "../forms/book_a_valuation";
import InstantValuation from "../forms/instant-valuation-form";

function ValuationForm({to_email_id, title, formLabel, branch_name, setResult, banner_image}) {
  const [valuation_form, setValuationForm] = useState("BV");

  return (
    <div className={`form ${valuation_form === "BV" ? "home-valuation" : valuation_form === "IOV" ? "instant-valuation" : ""}`}>
        <div className="valuation_from_wrapper">
            <label>{title ? title : "What type of valuation do you need?"}</label>
            <div className="val_form_btn">
                <a href="javascript:;" className={`btn ${valuation_form === "BV" ? "actv" : ""}`} onClick={() => setValuationForm("BV")}>Home Visit Valuation</a>
                <a href="javascript:;" className={`btn ${valuation_form === "IOV" ? "actv" : ""}`} onClick={() => setValuationForm("IOV")}>Instant Valuation</a>
            </div>
        </div>
        {valuation_form === "BV" ?
            <Book_A_Valuation banner_image={banner_image} />
            :
            <InstantValuation to_email_id={to_email_id} formLabel={branch_name} branch_name={branch_name} setResult={setResult} banner_image={banner_image}  />
        }

    </div>
  );
}


export default ValuationForm